module.exports = __webpack_public_path__ + "img/skillers_logo_new_white.28cdce29.png";